import {
  CameraPresenceConfig,
  CameraPresenceConfigRequest,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

/**
 * Sets or clears one camera's own presence switch. true/false override the
 * tenant setting for this camera; null clears the override so it inherits
 * again. The rules query carries the effective state, so it is refetched.
 */
export function useUpdateCameraPresence(
  camId: string,
  onSuccess?: (payload: CameraPresenceConfig) => void
) {
  const url = `/v2/orm/presence/cameras/${camId}/config`;
  const request = new Request(url, { method: 'PATCH' });

  return useAuthenticatedMutation<
    CameraPresenceConfig,
    CameraPresenceConfigRequest
  >(request, {
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    onSuccessInvalidationKeys: [['presence-rules', camId]],
    onSuccess,
  });
}

export default useUpdateCameraPresence;
